export default { sha: 'e3db8e283c5cc8b921306068b6beca32d4611720', buildNumber: 'undefined' }
